<template>
    <div>
        <b-modal
            :visible="value"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @ok="save"
            @hidden="hidden"
        >

            <template #modal-title>
                Edit Image
            </template>

            <b-form-group
                label="Embed Src"
            >
                <b-form-input v-model="editableEmbed.src" placeholder="https://" />
            </b-form-group>

            <b-form-group
                label="Width"
                label-for="width"
            >
                <!-- <b-form-input v-model="editableEmbed.width" /> -->

                <b-input-group>
                    <b-form-input type="number" v-model="editableEmbed.width" min="1" max="100" />
                    <b-input-group-append is-text>
                        %
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <b-form-group
                label="Height"
                label-for="height"
            >
                <b-input-group>
                    <b-form-input type="number" v-model="editableEmbed.height" min="1" max="1000" />
                    <b-input-group-append is-text>
                        px
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <b-form-group
                label="Align"
                label-for="align"
            >
                <b-form-select v-model="editableEmbed.align">
                    <b-form-select-option value="none">
                        None
                    </b-form-select-option>
                    <b-form-select-option value="left">
                        Left
                    </b-form-select-option>
                    <b-form-select-option value="right">
                        Right
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

            <!--            <b-form-group-->
            <!--                label="Alt"-->
            <!--                label-for="alt"-->
            <!--            >-->
            <!--                <b-form-textarea v-model="editableImage.alt" rows="3" />-->
            <!--            </b-form-group>-->

            <!--            <b-form-group-->
            <!--                label="Caption"-->
            <!--                label-for="caption"-->
            <!--            >-->
            <!--                <b-form-textarea v-model="editableImage.caption" rows="3" />-->
            <!--            </b-form-group>-->

            <!--            <b-form-group label="Credit" label-for="credit">-->
            <!--                <b-form-textarea v-model="editableImage.credit" rows="3" />-->
            <!--            </b-form-group>-->

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="save">
                    Save Changes
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>
export default {
    name: "ImageExtensionModal",
    data: () => ({
        editableEmbed: {}
    }),
    props: [
        'value',
        'view',
        'embed'
    ],
    components: {

    },
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    if (this.embed) {
                        if (this.embed.width) {
                            this.embed.width = this.embed.width.replace('%', '')
                        }
                        if (this.embed.height) {
                            this.embed.height = this.embed.height.replace('px', '')
                        }

                        this.editableEmbed = this.embed
                    }
                }
            }
        }
    },
    methods: {
        save () {
            this.$emit('save',this.editableEmbed);
        },
        cancel (event) {
            event.preventDefault()

            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')

            if (
                this.view &&
                this.view.dom
            ) {
                this.view.dom.focus()
            }
        }
    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
url,
.message {
    .copy-to-clipboard {
        visibility: hidden;
    }
    &:hover {
        .copy-to-clipboard {
            visibility: visible;
        }
    }
}

</style>